import { createFileRoute } from "@tanstack/react-router";
import TmsFortLauderdale from "@/pages/local/TmsFortLauderdale";
export const Route = createFileRoute("/tms-fort-lauderdale")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS Therapy Fort Lauderdale | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "TMS therapy for Fort Lauderdale patients at Neuro Wellness in Coral Springs — 30–40 min away. SAINT®, standard TMS, SPRAVATO® & ketamine. Free benefits verification.",
        },
        {
          property: "og:title",
          content: "TMS Therapy Fort Lauderdale | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "TMS therapy for Fort Lauderdale patients at Neuro Wellness in Coral Springs — 30–40 min away. SAINT®, standard TMS, SPRAVATO® & ketamine. Free benefits verification.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/tms-fort-lauderdale",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/tms-fort-lauderdale",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsFortLauderdale />;
}
